import styled from "styled-components";

export const LoansHeader = styled.h3`
  margin: 0;
  margin-top: 20px;
  padding: var(--sm) var(--lg);
  font-size: 14px;
  background: var(--ironside-gray);
  color: var(--white);
`;
